import React from 'react';
import { FadeIn } from './FadeIn';
export function PaolaSection() {
  return <section className="py-8 md:py-24 px-4 bg-white" data-id="element-370">
      <div className="max-w-4xl mx-auto" data-id="element-371">
        <FadeIn data-id="element-372">
          <div className="bg-white rounded-3xl p-6 md:p-12 border border-green-mint/30 shadow-soft flex flex-col md:flex-row gap-8 md:gap-12 items-center md:items-start" data-id="element-373">
            {/* Image Mobile (Top) / Desktop (Left) */}
            

            {/* Content */}
            <div className="flex-1 text-center md:text-left" data-id="element-374">
              
              

              <div className="space-y-4 text-text-main/80 font-body text-base leading-relaxed mb-8" data-id="element-375">
                <p data-id="element-376">
                  Mi hijo Giacomo tuvo su primer ciclo de antibióticos a los 8
                  meses. A los 2 años, ya había tenido 6.
                </p>
                <p data-id="element-377">
                  Cada invierno era lo mismo: jardín, moco, fiebre, consultorio,
                  antibiótico. Rinse and repeat.
                </p>
                <p data-id="element-378">
                  El pediatra era buenísimo. Hacía lo que podía. Pero nadie —{' '}
                  <strong data-id="element-379">nadie</strong> — me preguntó jamás qué estaba comiendo
                  Giacomo. Cómo estaba su intestino. Si había algo que yo
                  pudiera hacer antes de que llegara la infección.
                </p>
                <p data-id="element-380">
                  <strong data-id="element-381">Entonces lo busqué sola.</strong> Dos años de
                  investigación. Cientos de horas leyendo estudios sobre
                  microbioma, probióticos y compuestos antivirales naturales. Y
                  todo eso lo fui aplicando, de a poco,{' '}
                  <strong data-id="element-382">en la cocina de mi casa.</strong>
                </p>
              </div>

              <div className="bg-green-mint/20 p-6 rounded-2xl border-l-4 border-green-lime mb-8 relative" data-id="element-383">
                <span className="absolute -top-4 -left-2 text-6xl text-green-lime/30 font-serif" data-id="element-384">
                  "
                </span>
                <p className="font-heading font-bold text-xl text-green-deep relative z-10 italic" data-id="element-385">
                  A los 90 días, el pediatra me preguntó:
                  <br data-id="element-386" />
                  "Paola, ¿qué cambiaste? Porque este nene no es el mismo."
                </p>
              </div>

              <div className="space-y-4 text-text-main/80 font-body text-base leading-relaxed mb-8" data-id="element-387">
                <p data-id="element-388">
                  Decidí documentar todo en el manual que yo hubiera necesitado
                  aquella noche que me senté en una silla de hospital con
                  Giacomo dormido y un suero en el brazo.
                </p>
                <p className="font-bold text-text-main" data-id="element-389">
                  No soy médica. Soy una mamá que encontró el sistema — y lo
                  escribió para vos.
                </p>
              </div>

              
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}